/* =====================================================================================================
   NATALI PROFUMERIA · LAYER CRO — logica applicativa
   Percorso: assets/natali-cro.js   (file NUOVO, caricato con defer da snippets/natali-cro.liquid)

   Contiene:
     A) Modulo fattura elettronica nel carrello  (validazione IT + salvataggio negli attributi ordine)
     B) Banner "mancano X € alla spedizione gratuita" nella scheda prodotto

   Ottimizzazioni rispetto alla versione inline precedente:
     1. Niente fetch(/cart.js) all'avvio: il totale carrello arriva già da Liquid nell'attributo data-cart.
        La fetch parte SOLO se la pagina può essere stata servita da cache (attributo data-cart-stale),
        oppure dopo un evento cart:update. Si risparmia una richiesta di rete su ogni scheda prodotto.
     2. Il listener 'change' per il cambio variante non fa più `closest('form')` su ogni evento del
        documento (era il caso peggiore: un event handler che risale il DOM ad ogni digitazione).
     3. MutationObserver con debounce più alto e disconnessione automatica quando la sezione esce
        dal viewport.
     4. Il messaggio del banner arriva dalle impostazioni tema: niente stringhe italiane hard-coded,
        il sito resta traducibile.
     5. Validazione Partita IVA con controllo del codice di check (algoritmo di Luhn italiano),
        non più la sola lunghezza di 11 cifre: intercetta i refusi prima che diventino fatture sbagliate.
   ===================================================================================================== */

(function () {
  'use strict';

  if (window.__nataliCroInit) return;
  window.__nataliCroInit = true;

  /* -------------------------------------------------- Configurazione */
  var CFG = { root: '/', invoice: {}, shipping: {} };
  try {
    var cfgEl = document.getElementById('natali-cro-config');
    if (cfgEl) CFG = Object.assign(CFG, JSON.parse(cfgEl.textContent));
  } catch (e) { /* si prosegue con i valori di default */ }

  var ROOT = CFG.root || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');

  /* =====================================================================================
     A) MODULO FATTURA
     ===================================================================================== */
  var invoiceRoots = document.querySelectorAll('[data-natali-invoice]');

  function groupOf(el) {
    var g = el.closest('[data-inv-group]');
    return g ? g.getAttribute('data-inv-group') : 'comune';
  }

  function tipoOf(root) {
    var r = root.querySelector('[data-inv-tipo]:checked');
    return r ? r.value : 'Privato';
  }

  function applyTipo(root) {
    var tipo = tipoOf(root);
    root.querySelectorAll('[data-inv-group="privato"]').forEach(function (n) { n.hidden = tipo !== 'Privato'; });
    root.querySelectorAll('[data-inv-group="azienda"]').forEach(function (n) { n.hidden = tipo !== 'Azienda'; });
  }

  function setMsg(root, text, type) {
    var m = root.querySelector('[data-inv-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.classList.remove('is-ok', 'is-error');
    if (type) m.classList.add(type === 'ok' ? 'is-ok' : 'is-error');
  }

  function mark(input, bad) {
    if (input) input.classList.toggle('is-invalid', !!bad);
  }

  /* Partita IVA italiana: 11 cifre + cifra di controllo. Evita di mandare in fattura un numero
     formalmente lungo ma inesistente, che poi fa scartare la fattura dallo SdI. */
  function isValidPIVA(v) {
    if (!/^[0-9]{11}$/.test(v)) return false;
    var sum = 0;
    for (var i = 0; i < 11; i++) {
      var n = parseInt(v.charAt(i), 10);
      if (i % 2 === 1) {
        n *= 2;
        if (n > 9) n -= 9;
      }
      sum += n;
    }
    return sum % 10 === 0;
  }

  /* Codice fiscale: 16 alfanumerici nel formato corretto (6 lettere, 2 cifre, lettera, 2 cifre, lettera,
     3 alfanumerici, lettera). Accetta anche il CF numerico a 11 cifre delle persone giuridiche. */
  function isValidCF(v) {
    var s = v.toUpperCase();
    if (/^[0-9]{11}$/.test(s)) return isValidPIVA(s);
    return /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/.test(s);
  }

  function validate(root, tipo) {
    var ok = true, firstBad = null;

    function check(field, cond) {
      var inp = root.querySelector('[data-inv-field="' + field + '"]');
      if (!inp) return;
      var bad = !cond(inp.value.trim());
      mark(inp, bad);
      if (bad) { ok = false; if (!firstBad) firstBad = inp; }
    }

    var notEmpty = function (v) { return v.length > 0; };

    if (tipo === 'Azienda') {
      check('Ragione sociale', notEmpty);
      check('Partita IVA', isValidPIVA);

      var sdiInp = root.querySelector('[data-inv-field="Codice SDI"]');
      var pecInp = root.querySelector('[data-inv-field="PEC"]');
      var sdiOk = sdiInp ? /^[A-Za-z0-9]{7}$/.test(sdiInp.value.trim()) : false;
      var pecOk = pecInp ? /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(pecInp.value.trim()) : false;

      if (!sdiOk && !pecOk) {
        ok = false;
        mark(sdiInp, true);
        mark(pecInp, true);
        if (!firstBad) firstBad = sdiInp || pecInp;
      } else {
        mark(sdiInp, false);
        mark(pecInp, false);
      }
    } else {
      check('Nome e cognome', notEmpty);
      check('Codice fiscale', isValidCF);
    }

    check('Indirizzo', notEmpty);
    check('CAP', function (v) { return /^[0-9]{5}$/.test(v); });
    check('Città', notEmpty);
    check('Provincia', function (v) { return /^[A-Za-z]{2}$/.test(v); });

    if (!ok && firstBad) firstBad.focus();
    return ok;
  }

  var UPPERCASE_FIELDS = ['Codice fiscale', 'Codice fiscale azienda', 'Codice SDI', 'Provincia', 'Partita IVA'];

  function collect(root, enabled) {
    var tipo = tipoOf(root);
    var attrs = {};
    attrs['Fattura'] = enabled ? 'Sì' : '';
    attrs['Fattura - Tipo'] = enabled ? tipo : '';

    root.querySelectorAll('[data-inv-field]').forEach(function (inp) {
      var field = inp.getAttribute('data-inv-field');
      var g = groupOf(inp);
      var relevant = g === 'comune' ||
                     (g === 'privato' && tipo === 'Privato') ||
                     (g === 'azienda' && tipo === 'Azienda');
      var val = inp.value.trim();
      if (UPPERCASE_FIELDS.indexOf(field) > -1) val = val.toUpperCase();
      attrs['Fattura - ' + field] = (enabled && relevant) ? val : '';
    });

    return attrs;
  }

  function save(root, btn) {
    var enableEl = root.querySelector('[data-inv-enable]');
    var enabled = enableEl ? enableEl.checked : false;
    var tipo = tipoOf(root);

    if (enabled && !validate(root, tipo)) {
      setMsg(root, CFG.invoice.fix, 'error');
      return;
    }

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = CFG.invoice.saving;

    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: collect(root, enabled) })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function () {
        setMsg(root, enabled ? CFG.invoice.ok : CFG.invoice.removed, 'ok');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () { setMsg(root, CFG.invoice.error, 'error'); })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  }

  if (invoiceRoots.length) {
    invoiceRoots.forEach(applyTipo);

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (!t.matches('[data-inv-enable], [data-inv-tipo]')) return;

      var root = t.closest('[data-natali-invoice]');
      if (!root) return;

      if (t.matches('[data-inv-enable]')) {
        var fields = root.querySelector('[data-inv-fields]');
        if (fields) {
          fields.hidden = !t.checked;
          if (t.checked) {
            applyTipo(root);
            fields.scrollTop = 0;
            requestAnimationFrame(function () {
              try { fields.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (err) {}
            });
          }
        }
      } else {
        applyTipo(root);
      }
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-inv-save]');
      if (!btn) return;
      var root = btn.closest('[data-natali-invoice]');
      if (root) { e.preventDefault(); save(root, btn); }
    });
  }

  /* =====================================================================================
     B) BANNER SPEDIZIONE GRATUITA (scheda prodotto)
     ===================================================================================== */
  var shipFirst = document.querySelector('[data-natali-ship]');
  if (!shipFirst) return;

  var cartTotal = null;
  var symbol = CFG.shipping.currencySymbol || '€';

  function formatMoney(cents) {
    return symbol + '\u00A0' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function currentVariantPrice(el, prices) {
    var formId = el.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : el.closest('form');
    var idInput = form ? form.querySelector('[name="id"]') : document.querySelector('[name="id"]');
    var vid = idInput ? idInput.value : null;
    if (vid && prices[vid] != null) return prices[vid];
    var keys = Object.keys(prices);
    return keys.length ? prices[keys[0]] : 0;
  }

  /* Ogni banner puo' portare i propri messaggi negli attributi data-*; in mancanza usa quelli globali.
     Cosi' lo stesso motore governa sia la soglia spedizione sia quella dei campioncini omaggio. */
  function msgReached(el) {
    return el.getAttribute('data-msg-done') || CFG.shipping.reached || '';
  }

  function msgRemaining(el) {
    return el.getAttribute('data-msg-progress') || CFG.shipping.remaining || '';
  }

  function renderOne(el) {
    var threshold = parseInt(el.getAttribute('data-threshold') || '0', 10);
    var dataCart = parseInt(el.getAttribute('data-cart') || '0', 10);
    var cart = cartTotal != null ? cartTotal : dataCart;

    var priceScript = el.parentNode ? el.parentNode.querySelector('[data-natali-ship-prices]') : null;
    var prices = {};
    if (priceScript) { try { prices = JSON.parse(priceScript.textContent); } catch (e) {} }

    var textEl = el.querySelector('[data-ship-text]');
    var iconEl = el.querySelector('[data-ship-icon]');
    if (!textEl) return;

    var eff = cart + currentVariantPrice(el, prices);
    var done = eff >= threshold;
    var sig = done ? 'done' : 'miss:' + (threshold - eff);

    if (el.getAttribute('data-ship-sig') === sig) return;  // nessun cambiamento: evita il loop col MutationObserver
    el.setAttribute('data-ship-sig', sig);

    el.classList.toggle('natali-ship--done', done);
    if (iconEl) iconEl.textContent = done ? (el.getAttribute('data-icon-done') || '✅') : (el.getAttribute('data-icon') || '🚚');
    textEl.innerHTML = done
      ? msgReached(el)
      : (msgRemaining(el)).replace('[importo]', formatMoney(threshold - eff));
  }

  function renderAll() {
    document.querySelectorAll('[data-natali-ship]').forEach(renderOne);
  }

  /* Cambio variante: ascoltiamo solo gli input che contano, non ogni change del documento. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.name) return;
    if (t.name === 'id' || t.name.indexOf('option') === 0) renderAll();
  });

  /* Il totale carrello arriva già da Liquid. Lo rileggiamo dal server solo se serve davvero:
     pagina potenzialmente servita da cache, oppure carrello modificato dopo il caricamento. */
  function refreshCart() {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (c && typeof c.total_price === 'number') { cartTotal = c.total_price; renderAll(); }
      })
      .catch(function () {});
  }

  document.addEventListener('cart:update', refreshCart);
  document.addEventListener('cart:refresh', refreshCart);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  if (shipFirst.hasAttribute('data-cart-stale')) refreshCart();

  renderAll();

  /* Osserviamo i re-render della sola sezione prodotto, e solo mentre è visibile. */
  if (window.MutationObserver && 'IntersectionObserver' in window) {
    var scope = shipFirst.closest('product-info, .shopify-section, main') || document.body;
    var timer = null;
    var mo = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(renderAll, 200);
    });

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          mo.observe(scope, { childList: true, subtree: true });
        } else {
          mo.disconnect();
        }
      });
    }, { rootMargin: '200px' }).observe(scope);
  }
})();
